<ng-container [ngSwitch]="state">
  <ng-content *ngSwitchCase="State.Empty" select="empty-state"></ng-content>
  <ng-content *ngSwitchCase="State.Loading" select="loading-state"></ng-content>
  <ng-content *ngSwitchCase="State.Content" select="content-state"></ng-content>
  <ng-content *ngSwitchCase="State.Error" select="error-state"></ng-content>
</ng-container>
